import { BookType } from "shared";

import { AnalyticsApi } from "../firestore/queries/queriesCommon";

const STORAGE_PREFIX = "publizm-analytics-purchase:";
const loggedOrders = new Set<string>();

export type AnalyticsPurchase = {
    orderId: string;
    bookId: string;
    title?: string;
    bookType?: BookType;
    valueNok: number;
};

function stored(orderId: string): boolean {
    try {
        return window.localStorage.getItem(STORAGE_PREFIX + orderId) !== null;
    } catch {
        return false;
    }
}

/**
 * Logs the Firebase Analytics purchase once per orderId for a payment seen as Vipps AUTHORIZED.
 * `valueNok` is in NOK, not øre. orderId is the transaction_id, so Google Analytics can also deduplicate.
 */
export function logAuthorizedPurchase({ orderId, bookId, title, bookType, valueNok }: AnalyticsPurchase): boolean {
    if (!orderId || !bookId || !Number.isFinite(valueNok) || valueNok <= 0) return false;
    if (loggedOrders.has(orderId) || stored(orderId)) return false;
    loggedOrders.add(orderId);
    AnalyticsApi.logPurchase(valueNok, bookId, title, orderId, bookType);
    try {
        window.localStorage.setItem(STORAGE_PREFIX + orderId, "1");
    } catch {
        // The in-memory set and transaction_id deduplication still apply.
    }
    return true;
}
